module.exports = __webpack_public_path__ + "media/raise_capital/cta-a53b342c.jpg";